import { render, staticRenderFns } from "./UZB.vue?vue&type=template&id=db954512&scoped=true&"
import script from "./UZB.vue?vue&type=script&lang=js&"
export * from "./UZB.vue?vue&type=script&lang=js&"
import style0 from "./UZB.vue?vue&type=style&index=0&id=db954512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db954512",
  null
  
)

export default component.exports